import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { LoadingDots } from "PFComponents/loading_dots";
import { useActivity, useActivityEconomicsScenario } from "PFCore/hooks/queries/activity";
import { useActivityEconomicsScenarioInvalidate } from "PFCore/hooks/queries/activity/use_activity_economics_scenario_invalidate";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { useUnmount } from "react-use";

import { useEconomicsPermissions } from "../show/hooks/use_economics_permissions";
import { ScenarioView } from "./scenario_view";
import { getEconomicsUrl } from "./utils";

export const ScenarioShowController = () => {
  const { t } = useTranslation("activities", { keyPrefix: "scenario" });
  const { showGrowl } = useGrowlStoreActions();
  const navigate = useNavigate();
  const { id, scenarioId } = useParams<{ id: string; scenarioId: string }>();

  const { canViewScenario } = useEconomicsPermissions();

  const { data: activity, isLoading: isLoadingActivity } = useActivity(id || "", {
    enabled: !!id
  });
  const { invalidate: invalidateScenario } = useActivityEconomicsScenarioInvalidate();

  useEffect(() => {
    if (activity && !activity.coowned && !canViewScenario) {
      navigate(getEconomicsUrl(activity.id), { replace: true });
      showGrowl({ message: t("notPermitted"), kind: "error" });
    }
  }, [activity, canViewScenario, showGrowl, navigate, t]);

  const {
    data: scenario,
    isFetching: isFetchingScenario,
    error: scenarioError,
    errorUpdatedAt: scenarioErrorUpdatedAt
  } = useActivityEconomicsScenario(scenarioId || "", {
    enabled: !!scenarioId && !!activity
  });

  useEffect(() => {
    if (scenarioError?.status === 422) {
      navigate(getEconomicsUrl(activity!.id), { replace: true });
      showGrowl({ message: t("notPermitted"), kind: "error" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scenarioErrorUpdatedAt]);

  //matches may not be ready so we want to reload
  //scenario in case matches updated for select input options
  useUnmount(() => scenarioId && invalidateScenario(scenarioId));

  if (!scenario || !activity || isLoadingActivity) {
    return <LoadingDots circlesEnabled centered pageViewEnabled />;
  }

  return <ScenarioView activity={activity} scenario={scenario} isFetchingScenario={isFetchingScenario} />;
};
